module.exports = __webpack_public_path__ + "img/logo.376aea91.png";